<template>
  <div>
    <div id="captcha-element"></div>
    <!-- <button id="refresh-button" @click="initCaptcha">重新初始化验证码</button> -->
  </div>
</template>

<script>
export default {
  name: 'Captcha',
  emits: ['success', 'fail'],

  data() {
    return {
      captcha: null,
      errorCount: 0, // 错误计数器
      isDeadlyError: false // 是否进入熔断状态
    }
  },
  methods: {
    getInstance(instance) {
      this.captcha = instance
    },
    success(captchaVerifyParam) {
      console.log('captchaVerifyParam--', captchaVerifyParam)
      if(captchaVerifyParam) {
        this.$emit('success', captchaVerifyParam)
        // 成功后根据业务需求决定是否重置
        console.log('this.captcha00', this.captcha)
        if (this.captcha && typeof this.captcha.reset === 'function') {
          this.captcha.reset();
        } else {
          console.warn('验证码实例尚未就绪或不支持 reset');
          // 如果实例坏了，干脆清空，下次 show 时触发重新初始化
          this.captcha = null;
        }
      }
 
    },
    fail(error) {
      this.errorCount++;
      console.error(`验证码第 ${this.errorCount} 次失败:`, error);

      // 1. 尝试正常重置
      if (this.captcha && typeof this.captcha.reset === 'function') {
        this.captcha.reset();
      } else {
         this.captcha = null;
      }

      // 2. 核心逻辑：熔断处理
      // 如果短时间内连续失败超过 3 次，判定为环境或配置问题，彻底销毁
      if (this.errorCount >= 3) {
        this.isDeadlyError = true;
        this.destroyCaptcha();
        this.$emit('fail', '验证码服务暂时不可用，请稍后再试');
      }
    },
    destroyCaptcha() {
    // 物理清空 DOM，阻断 SDK 的所有后续异步请求渲染
    const container = document.getElementById('captcha-element');
    if (container) {
      container.innerHTML = '';
    }
    // 清除实例引用
    this.captcha = null;
    // 此时不再尝试 initCaptcha，除非用户手动刷新页面
    console.warn("检测到服务持续 503，已强制关停验证码组件防止浏览器卡死");
  },
    initCaptcha() {
      // 检查 window 下是否已有实例，或组件内是否已初始化
      if (this.captcha || window.aliyunCaptchaInstance) {
        return;
      }
      window.initAliyunCaptcha({
        SceneId: '12qsp3dw',
        mode: 'popup',
        element: '#captcha-element',
        immediate: false,
        success: this.success,
        fail: this.fail,
        getInstance: this.getInstance,
        language: 'cn',
      })
    },
    show() {
    if (this.captcha) {
      this.captcha.show(); // 如果已经有实例，直接弹
    } else {
      console.log('实例尚未初始化，正在尝试初始化并弹出...');
      this.initCaptcha();
      // 给 SDK 一点点加载时间后再弹
      setTimeout(() => {
        this.captcha?.show();
      }, 500);
    }
  }
  },
}
</script>

<style>
#captcha-button {
  z-index: 99;
  width: 150px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  background-color: hsla(160, 100%, 37%, 1);
  color: #fff;
  padding: 8px 0;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}
</style>
